<!-- introduction Section -->
<section id="introduction" class="content-section">
    <div class="row" appDynamicDirection>
        <div class="container">
        <div class="col-lg-12">
            <h2 class="heading" i18n>Online course for capacity building</h2>
            <p i18n>The SDG-PSS is designed as an online user-friendly tool. Users are expected to learn how to use and operate the main features of the tool. However, filling the SDG-PSS with data may be time-consuming and complex for some professionals. An online course is available to provide training on how to use the tool in a systematic and effective approach manner. The online course can be accessed at the
                <strong>UNU Online <a href="{{src_url}}" target="blank">Learning Center</a></strong>.
                <br><br>
                On completion of this self-paced online course, participants should be able to access the SDG-PSS online, navigate through the SDG-PSS pages and its critical components, and use the SDG-PSS to generate and analyze evidence on the national progress towards the achievement of SDG 6.

              </p>
        </div>
        <div class="col-lg-12" style="margin-top: 20px;">
            <a class="btn-lg btn btn-info btn-radius" style="margin: 15px 0; min-width: 150px;" routerLink="/introduction/summary" i18n>Back</a>
            <a class="btn-lg btn btn-primary btn-radius" style="margin: 15px 0; min-width: 150px" routerLink="/home" i18n>Home</a>
        </div>
        </div>
    </div>
</section>



// WEBPACK FOOTER //
// ./src/app/introduction/ecourse/ecourse.component.html